<template>
    <span>
        <div class="custom-collapse-element">
            <h3 class="sidebar-title-main">{{ $t('floatBox.sidebarTitle') }}</h3>
            <div id="accordion">
                <div class="card" v-if="contractModule.contracts.filter((contract) => contract.isMobile).length > 0">
                    <div class="card-heading" id="headingMobile">
                        <h3 class="sidebar-title"
                            data-toggle="collapse"
                            data-target="#collapseMobile"
                            aria-expanded="true"
                            aria-controls="collapseMobile"
                            :class="{'collapsed': !contractModule.clickedContract.isMobile}"
                        >
                            {{ $t('floatBox.titleMobile') }}
                        </h3>
                    </div>

                    <div id="collapseMobile"
                        :class="{'collapse': true, 'show': contractModule.clickedContract.isMobile && screenWidth > 1024}"
                        aria-labelledby="headingMobile"
                        data-parent="#accordion"
                        ref="floatBoxMenu"
                    >
                        <div class="card-body">
                            <div id="accordion2">
                                <div class="card" v-for="(contract, index) in contractModule.contracts.filter((contract) => contract.isMobile && contract.statusReason == 'Active')" :key="index">
                                    <div :id="'heading' + index">
                                        <ul :class="{
                                            'sidebar-list-phone-numbers': true,
                                            'active': contract.contractId === contractModule.clickedContract.contractId && contract.productId === contractModule.clickedContract.productId
                                        }"
                                            @click="setClickedContract(contract)"
                                        >
                                            <li class="phone-number"
                                                data-toggle="collapse"
                                                :data-target="'#collapse' + index"
                                                aria-expanded="true"
                                                :aria-controls="'collapse' + index"
                                            >
                                                <span class="icon-new-uredjaji"></span>
                                                <p class="sidebar-number">{{ contract.phoneNumber }}</p>
                                                <span class="number-type">{{ contract.contractType | contractTypeChangeLanguage }}</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div :id="'collapse' + index"
                                        :class="{'collapse': true, 'show': index === 0}"
                                        :aria-labelledby="'heading' + index"
                                        data-parent="#accordion2"
                                    
                                    >
                                        <div class="card-body">
                                            <ul class="sidebar-list-link">
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'bills'}">{{ $t('pages.bills.name') }}</router-link>
                                                </li>
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'listing'}">{{ $t('pages.phoneListing.name') }}</router-link>
                                                </li>
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'rechargeCredit'}">{{ $t('pages.rechargeCredit.name') }}</router-link>
                                                </li>
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'packages'}">{{ $t('pages.additionalPackages.name') }}</router-link>
                                                </li>
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'resources'}">{{ $t('myTariff') }}</router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-if="contractModule.contracts.filter((contract) => contract.isTv && contract.statusReason == 'Active').length > 0">
                    <div class="card-heading" id="headingTv">
                        <h3 class="sidebar-title"
                            data-toggle="collapse"
                            data-target="#collapseTv"
                            aria-expanded="true"
                            aria-controls="collapseTv"
                            :class="{'collapsed': !contractModule.clickedContract.isTv}"
                        >
                            {{ $t('floatBox.titleTv') }}
                        </h3>
                    </div>
                    <div id="collapseTv"
                        :class="{'collapse': true, 'show': contractModule.clickedContract.isTv && screenWidth > 1024}"
                        aria-labelledby="headingTv"
                        data-parent="#accordion"
                        ref="floatBoxMenuTv"
                    >
                        <div class="card-body">
                            <div id="accordion3">
                                <div class="card" v-for="(contract, index) in contractModule.contracts.filter((contract) => contract.isTv)" :key="index">
                                    <div :id="'headingTv' + index">
                                        <ul :class="{
                                            'sidebar-list-phone-numbers': true,
                                            'active': contract.contractId === contractModule.clickedContract.contractId && contract.productId === contractModule.clickedContract.productId
                                        }"
                                            @click="setClickedContract(contract)"
                                        >
                                            <li class="phone-number"
                                                data-toggle="collapse"
                                                :data-target="'#collapseTv' + index"
                                                aria-expanded="true"
                                                :aria-controls="'collapseTv' + index"
                                            >
                                                <span class="icon-new-tv"></span>
                                                <p class="sidebar-number">{{ contract.displayName }}</p>
                                                <span class="number-type">{{ contract.contractType | contractTypeChangeLanguage }}</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div :id="'collapseTv' + index"
                                        :class="{'collapse': true}"
                                        :aria-labelledby="'headingTv' + index"
                                        data-parent="#accordion3"
                                    
                                    >
                                        <div class="card-body">
                                            <ul class="sidebar-list-link">
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'bills'}">{{ $t('pages.bills.name') }}</router-link>
                                                </li>
                                                <!-- <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'tvTariffs'}">{{ $t('tvTariffs') }}</router-link>
                                                </li> -->
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'tv'}">{{ $t('myTvTariff') }}</router-link>
                                                </li>
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'tvPassword'}">{{ $t('myTvPassword') }}</router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-if="contractModule.contracts.filter((contract) => contract.isInternet && contract.statusReason == 'Active').length > 0">
                   <div class="card-heading" id="headingInternet">
                        <h3 class="sidebar-title"
                            data-toggle="collapse"
                            data-target="#collapseInternet"
                            aria-expanded="true"
                            aria-controls="collapseInternet"
                            :class="{'collapsed': !contractModule.clickedContract.isInternet}"
                        >
                            {{ $t('floatBox.titleInternet') }}
                        </h3>
                    </div>
                    <div id="collapseInternet"
                        :class="{'collapse': true, 'show': contractModule.clickedContract.isInternet && screenWidth > 1024}"
                        aria-labelledby="headingInternet"
                        data-parent="#accordion"
                        ref="floatBoxMenuInternet"
                    >
                        <div class="card-body">
                            <div id="accordion3">
                                <div class="card" v-for="(contract, index) in contractModule.contracts.filter((contract) => contract.isInternet)" :key="index">
                                    <div :id="'headingInternet' + index">
                                        <ul :class="{
                                            'sidebar-list-phone-numbers': true,
                                            'active': contract.contractId === contractModule.clickedContract.contractId && contract.productId === contractModule.clickedContract.productId
                                        }"
                                            @click="setClickedContract(contract)"
                                        >
                                            <li class="phone-number"
                                                data-toggle="collapse"
                                                :data-target="'#collapseInternet' + index"
                                                aria-expanded="true"
                                                :aria-controls="'collapseInternet' + index"
                                            >
                                                <span class="icon-new-internet"></span>
                                                <p class="sidebar-number">{{ contract.displayName }}</p>
                                                <span class="number-type">{{ contract.contractType | contractTypeChangeLanguage }}</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div :id="'collapseInternet' + index"
                                        :class="{'collapse': true}"
                                        :aria-labelledby="'headingInternet' + index"
                                        data-parent="#accordion3"
                                    
                                    >
                                        <div class="card-body">
                                            <ul class="sidebar-list-link">
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'bills'}">{{ $t('pages.bills.name') }}</router-link>
                                                </li>
                                                <li @click="setClickedContract(contract)">
                                                    <router-link :to="{ name: 'internet'}">{{ $t('myInternetTariff') }}</router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
import FloatBox from './FloatBox';
export default FloatBox;
</script>

<style lang="scss">
    #headingMain {
        padding: 20px 0 0 0;
    }
    h3 {
        font-size: 20px;
        margin: 0;
        text-align: center;
        cursor: pointer;
    }

</style>
